import { AmplitudeEvents, sendAmplitudeEvent } from '@repo/analytics/amplitude/utils'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { usePaymentsDialog } from 'payments/components/payments-dialog-wrapper-context'
import {
  PAYMENT_ENTRY_POINTS,
  savePaymentModalEntryPoint,
} from 'payments/payments-dialog/analytics'
import {
  useTranslations,
  useForceIsAllAccess,
  useForceIsLoggedIn,
} from '../contexts/header-config-context'
import { useUserQuery, userQueryOptions } from 'auth/hooks'
import { isLoggedInQuerySelector } from '@repo/cf-user/selectors'
import { GradientColoredSparkIcon } from './icons/gradient-colored-spark-icon'
import { SparkInpaintingIcon } from './icons/spark-inpainting-icon'
import * as MenuItem from './menu-item'

export function MarketplaceHeaderCTA({ layout }: { layout: 'desktop' | 'mobile' }) {
  const { data: resolvedUser } = useUserQuery(undefined, {
    ...userQueryOptions,
    select(data) {
      return {
        isLoggedIn: isLoggedInQuerySelector(data),
        hasAllAccess: data.me?.user?.subscriptionAccess.allAccess.isSubscribed || false,
      }
    },
  })
  const forceIsLoggedIn = useForceIsLoggedIn()
  const forceIsAllAccess = useForceIsAllAccess()
  const isLoggedIn = resolvedUser?.isLoggedIn ?? forceIsLoggedIn ?? false
  const hasAllAccess = isLoggedIn && (resolvedUser?.hasAllAccess ?? forceIsAllAccess ?? false)
  const t = useTranslations()
  const { open } = usePaymentsDialog()

  const isMobile = layout === 'mobile'
  const className = isMobile
    ? 'ml-4 h-full flex-col justify-between gap-1 px-2 py-1.5'
    : 'ml-4 min-w-24 py-1.5 px-3'
  const variant = isMobile ? 'default' : 'colored'
  const content = (
    <>
      {isMobile ? (
        <GradientColoredSparkIcon />
      ) : (
        <SparkInpaintingIcon className="text-cf-white drop-shadow-cf-elevation-light-1 h-5" />
      )}
      <span
        className={
          isMobile
            ? 'min-w-14 text-center drop-shadow'
            : 'drop-shadow-cf-elevation-light-1 text-14 whitespace-nowrap'
        }
      >
        {hasAllAccess ? t('top_nav.content_create') : t('top_nav.try_for_free')}
      </span>
    </>
  )
  const trackClick = () => {
    savePaymentModalEntryPoint(PAYMENT_ENTRY_POINTS.MAIN_MENU_STUDIO_BUTTON)
    sendAmplitudeEvent(AmplitudeEvents.MAIN_MENU_STUDIO_BUTTON_CLICKED)
  }

  if (hasAllAccess) {
    return (
      <MenuItem.Link
        href={AppRoutes.TOOLS}
        target="_self"
        className={className}
        variant={variant}
        onClick={trackClick}
      >
        {content}
      </MenuItem.Link>
    )
  }

  if (!isLoggedIn) {
    return (
      <MenuItem.Link
        href={AppRoutes.B_FREE_TRIAL}
        target="_self"
        className={className}
        variant={variant}
        onClick={trackClick}
      >
        {content}
      </MenuItem.Link>
    )
  }

  return (
    <MenuItem.Button
      type="button"
      className={className}
      variant={variant}
      onClick={() => {
        trackClick()
        if (window.cfOpenPaymentsDialog) {
          window.cfOpenPaymentsDialog({ defaultPlan: 'freeTrial' })
        } else {
          open('freeTrial')
        }
      }}
    >
      {content}
    </MenuItem.Button>
  )
}
